import React from "react";
import { useSelector } from "react-redux";
import { TableLoader } from "../../components/tableLoader";
import { TableModel } from "../../../personal-studio-components/table/TableModel";

function PracticesInfo() {
  const { contractId } = useSelector((state) => state.contract);
  const { access_token } = useSelector((state) => state.token);
  const loader = {
    title: "Сведения о практиках",
    icon: "survey",
    request: {
      method: "post",
      path: "/student/practices_info",
      data: { access_token, study_contract_id: contractId },
    },
    parser: createModel,
  };
  function createModel(response) {
    const table = new TableModel(response);

    table.columns.forEach((element) => {
      if (element.field === "dates") {
        element.type = "date";
      }
    });
    table.columns = table.columns.filter(
      (el) => el.field !== "contract_practice_id"
    );
    return table;
  }
  return <TableLoader {...loader} />;
}

export default PracticesInfo;
